<template>
    <div class="app-header-nav-main">
        <div class="app-header">
            <nav class="navbar navbar-light navbar-expand-lg bg-white p-0 border-0 fixed-top shadow">
                <router-link to="/" class="navbar-brand py-3 py-lg-4 px-3 primary-bg primary-nav-logo">
                    <img :src="headerLogo" alt="Logo" height="100px">
                </router-link>

                <button class="navbar-toggler mr-5" type="button" data-toggle="collapse" data-target="#navbar-main" aria-controls="navbar-main" aria-expanded="false" aria-label="Toggle navigation"
                    @click="toggleSideNav($event)"
                >
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class="collapse navbar-collapse container-fluid d-none d-lg-block" id="navbar-main">
                    <ul class="nav navbar-nav ml-md-auto text-uppercase">
                        <li class="nav-item px-md-3">
                            <router-link to="/" class="nav-link" exact>Home <span class="sr-only">(current)</span></router-link>
                        </li>
                        <li class="nav-item px-md-3">
                            <router-link to="/about-us" class="nav-link" exact>ABOUT US</router-link>
                        </li>
                        <li class="nav-item px-md-3">
                            <router-link to="/practice-areas" class="nav-link" exact>PRACTICE AREAS</router-link>
                        </li>
                        <li class="nav-item px-md-3">
                            <router-link to="/articles" class="nav-link" exact>ARTICLES</router-link>
                        </li>
                        <li class="nav-item px-md-3">
                            <router-link to="/careers" class="nav-link" exact>CAREERS</router-link>
                        </li>
                        <li class="nav-item px-md-3">
                            <router-link to="/contact-us" class="nav-link" exact>CONTACT US</router-link>
                        </li>

                        
                    </ul>
                </div>
            </nav>
        </div>

        <div class="mobile-nav-overlay" @click="toggleSideNav($event)"></div>

        <div class="mobile-nav  d-lg-none">
            <div class="logo-bg">
                <img :src="headerLogo" alt="">
                <span class="pl-4 close-nav" @click="toggleSideNav($event)">
                    <i class="ti-close text-white "></i>
                </span>
            </div>

            <div class="nav-links">
                <ul>
                    <li>
                        <a class="waves-effect" @click="navigateTo('/')">Home</a>
                    </li>
                    <li>
                        <a class="waves-effect" @click="navigateTo('/about-us')">About Us</a>
                    </li>
                    <li>
                        <a class="waves-effect" @click="navigateTo('/practice-areas')">Practice Areas</a>
                    </li>
                    <li>
                        <a class="waves-effect" @click="navigateTo('/articles')">Articles</a>
                    </li>
                    <li>
                        <a class="waves-effect" @click="navigateTo('/careers')">Careers</a>
                    </li>
                    <li>
                        <a class="waves-effect" @click="navigateTo('/contact-us')">Contact Us</a>
                    </li>
                    
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    let headerLogo = require('@/assets/img/header-logo.png');
    export default {
        name: 'Header',
        metaInfo: {
            link: []
        },
        data() {
            return {
                headerLogo: headerLogo
            }
        },
        methods: {
            toggleSideNav(e) {
                let mobileNav = document.querySelector('.mobile-nav');
                let body = document.querySelector('body');
                let mobileNavOverlay = document.querySelector('.mobile-nav-overlay');
                mobileNav.classList.toggle('toggled-nav');
                mobileNavOverlay.classList.toggle('displayed');
                body.classList.toggle('overflow-hidden-body');
            },

            navigateTo(anchor) {
                let mobileNav = document.querySelector('.mobile-nav');
                let body = document.querySelector('body');
                let mobileNavOverlay = document.querySelector('.mobile-nav-overlay');
                mobileNav.classList.remove('toggled-nav');
                mobileNavOverlay.classList.remove('displayed');
                body.classList.remove('overflow-hidden-body');

                this.$router.push(anchor);
            }
        }
    }
</script>






// WEBPACK FOOTER //
// src/components/frontend/templates/Header.vue